import {
  type SbcSubsection,
  type SolveSbcArgs,
  buildSolveSbcProps,
} from "@repo/shared/analytics";

import { mixpanelTrack } from "./mixpanelTrack";

const SECTION = "SBC";

// The SBC event vocabulary (category map, scope, filter keys, solve_sbc props)
// lives in @repo/shared/analytics so web and mobile stay one taxonomy. Web
// keeps its own transport (mixpanelTrack → mixpanel-browser); it only reuses
// the shared prop builder.

export const trackSolveSbc = (args: SolveSbcArgs) =>
  mixpanelTrack("solve_sbc", buildSolveSbcProps(args));

export const trackSolveSbcAgain = (args: SolveSbcArgs) =>
  mixpanelTrack("solve_sbc_again", buildSolveSbcProps(args));

export const trackPlayerSwapAccept = () =>
  mixpanelTrack("player_swap_accept", {
    section: SECTION,
    subsection: "Solution View",
    action_type: "core",
  });

export const trackSendToExtension = () =>
  mixpanelTrack("send_to_extension", {
    section: SECTION,
    subsection: "Solution View",
    action_type: "core",
  });

// `import_club` now comes from events/clubImportMixpanel, fired once at the
// launch chokepoint with this section as its origin.

export const trackViewPlayerContent = (
  subsection: SbcSubsection = "Overview",
) => {
  mixpanelTrack("view_content", {
    section: SECTION,
    subsection,
    content_type: "player",
    action_type: "browse",
  });
};
